import { render, staticRenderFns } from "./ShipmentRequiredBookingFields.vue?vue&type=template&id=6afdfc90&scoped=true&"
import script from "./ShipmentRequiredBookingFields.vue?vue&type=script&lang=js&"
export * from "./ShipmentRequiredBookingFields.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentRequiredBookingFields.vue?vue&type=style&index=0&id=6afdfc90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afdfc90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6afdfc90')) {
      api.createRecord('6afdfc90', component.options)
    } else {
      api.reload('6afdfc90', component.options)
    }
    module.hot.accept("./ShipmentRequiredBookingFields.vue?vue&type=template&id=6afdfc90&scoped=true&", function () {
      api.rerender('6afdfc90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/BookingFields/components/ShipmentRequiredBookingFields.vue"
export default component.exports